export type AccountTabKey = "profile" | "security" | "integrations"

// gestion-staff-my-account: tabs de "Mi cuenta" — son RUTAS hermanas, no
// estado de cliente, mismo mecanismo que ModuleLayout ya usa en otras
// páginas de detalle (ver WaitlistDetailPage.tsx / StaffUsersPage.tsx).
export function accountTabs(active: AccountTabKey) {
  return [
    { label: "Perfil", to: "/account", active: active === "profile" },
    { label: "Seguridad", to: "/account/security", active: active === "security" },
    { label: "Integraciones", to: "/account/integrations", active: active === "integrations" },
  ]
}
